import { useTranslation } from "react-i18next";
import { useLoading } from "../../Context/LoadingProvider";
import { RiderProfileLayoutContextInterface } from "./RiderProfileLayout";
import { /*useEffect,*/ useState } from "react";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import { riderService } from "../../Api/Services/RiderService";
import ImageInput from "../../Components/ImageInput";

interface ChangeImageProps {}

const ChangeImage: React.FunctionComponent<ChangeImageProps> = () => {
  const { t } = useTranslation();
  const { startLoading, finnishLoading } = useLoading();
  const { /*setPageTitle,*/ rider, setRider } =
    useOutletContext<RiderProfileLayoutContextInterface>();

  //useEffect(() => {
  //  setPageTitle(t("Change Image"));
  //}, [t, setPageTitle]);

  const [images, setImages] = useState<File[]>([]);
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    startLoading("update-rider-profile");
    riderService
      .update(rider.riderId, true, null, rider.vehicle, images[0] ?? null)
      .then((rider) => {
        setRider(rider);
        navigate(`/rider/${rider.riderId}/profile`);
      })
      .finally(() => {
        finnishLoading("update-rider-profile");
      });
  };
  return (
    <>
      <form className="" onSubmit={handleSubmit}>
        <div className="mb-4">
          <ImageInput
            images={images}
            setImages={setImages}
            title={t("Take Rider Picture")}
            multiple={false}
            required={true}
          />
        </div>


        <div className="flex items-center gap-4 pb-4">
          <div className="flex-1">
            <Link to={`/rider/${rider.riderId}/profile`} className="button button--light">
              {t("Back")}
            </Link>
          </div>
          <div className="flex-1">
            <button type="submit" className="button">
              {t("Save")}
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default ChangeImage;
